export enum ProductType {
    DSL = 'dsl',
    FIBER = 'fibre',
    CABLE = 'cable',
    PRE_FIBER = 'pre-fibre',
}

export enum MetacodePrefix {
    CABLE = 'kip',
    DSL = 'DSL',
    FIBER = 'FIB',
    PRE_FIBER = 'PRE-FIB',
}

export enum CableProviderType {
    KDG = 'kabel deutschland',
    UME = 'unitymedia'
}

export enum HomesPassedType {
    BHS = 'bhs',
    BKV = 'bkv',
}

export enum AccessSupplier {
    VFDE = 'VFDE',
    DTAG = 'DTAG',
    DGW = 'DGW'
}

export enum AvailabilityIndicator {
    GELB_GRAU = 'GELB_GRAU',
    ORANGE = 'ORANGE',
    GRUEN = 'GRUEN',
    ORANGE_ROT = 'ORANGE_ROT',
    ROT_ORANGE = 'ROT_ORANGE'
}
